import adminRoutes from 'innovate/adminRoutes';
import withApprovalProvider from 'innovate/utils/withApprovalProvider';
import { lazy } from 'react';
import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v6';

const Homepage = lazy(() => import('innovate/pages/Homepage/Homepage'));
const Request = lazy(() => import('innovate/pages/RequestPage/RequestPage'));
const PreLaunchPage = lazy(() => import('innovate/pages/Pre-launch/PreLaunchPageRefactored'));
const ComparePage = lazy(() => import('innovate/pages/ComparePage/ComparePage'));
const ResultPageRefactored = lazy(
  () => import('innovate/pages/ResultPageRefactored/ResultPageRefactored')
);
const ErrorPage = lazy(() => import('innovate/pages/Unauthorized/ErrorPage'));
const InnoExplore = lazy(() => import('innovate/pages/InnoExplore/InnoExplore'));
const GlobalView = lazy(() => import('innovate/pages/InnoExplore/GlobalView'));

const InnoImpact = lazy(() => import('innovate/pages/InnoImpact/InnoImpact'));
const NotFoundPage = lazy(() => import('innovate/pages/Unauthorized/NotFoundPage'));

const router = createBrowserRouter([
  {
    path: '/',
    children: [
      {
        index: true,
        Component: Homepage,
      },
      {
        path: 'pack-price',
        children: [
          {
            index: true,
            Component: withApprovalProvider(<InnoExplore />),
          },
          {
            path: 'global-view',
            Component: withApprovalProvider(<GlobalView />),
          },
        ],
      },
      {
        path: 'pre-launch',
        children: [
          {
            index: true,
            Component: withApprovalProvider(<PreLaunchPage />),
          },
          {
            path: 'compare',
            Component: withApprovalProvider(<ComparePage />),
          },
          {
            path: 'new-simulation',
            Component: withApprovalProvider(<ResultPageRefactored />),
          },
          {
            path: 'edit-simulation',
            Component: withApprovalProvider(<ResultPageRefactored />),
          },
        ],
      },

      {
        path: 'post-launch',
        Component: withApprovalProvider(<InnoImpact />),
      },
      {
        path: '/404',
        Component: ErrorPage,
      },
      {
        path: 'access',
        children: [
          {
            index: true,
            Component: withApprovalProvider(<Request />),
          },
        ],
      },
      {
        path: '*',
        Component: NotFoundPage,
      },
    ],
  },
  ...adminRoutes,
]);

export default router;
